export const base = 'font-noto-ikea text-input-label';
